<template>
    <div v-if='cData' type='button' @click='queryCalledDetail' class='h-ts-e-button h-ts-e-button-click-color'>
        <span>{{$ts('TS.ts_call_detail')}}</span>
    </div>
    <div v-else type='button' class='h-ts-e-button h-ts-e-button-no-click-color'>
        <span>{{$ts('TS.ts_call_detail')}}</span>
    </div>
</template>
<script>
import bus from '../bus.js';
import i18n from '../../../plugins/i18n.js';
export default {
    name: 'DigitalDetailColumnButton',
    data() {
        return {
            data: {}
        }
    },
    computed: {
        cData: function() {
            return this.data.callResult !== 0 && this.data.uuId !== '' && this.data.callType !== 1 && this.data.callType !== 3;
        }
    },
    methods: {
        $ts(args) {
            const mes = args.split('.');
            const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
            return result;
        },
        queryCalledDetail(){
            const params = {
                neId: this.data.neId,
                uuid: this.data.uuId,
                beginTime: this.data.sendTime
            };
            bus.$emit('digitalCalledDetail', params);
        }
    }
};
</script>
<style scoped>
    .h-ts-e-button {
        position: relative;
        border: none;
        /*padding: 4px 9px;*/
        cursor:pointer;
        border-radius: 5px;
        margin:0 auto;
        text-align: center;
        text-decoration: none;
        color: white;
    }
    .h-ts-e-button-click-color{
        background-color: #007BFF;
    }
    .h-ts-e-button-no-click-color{
        background-color: #6c757d;
    }
</style>
